export { InformationCircle as default } from './InformationCircle';
